import React, { useEffect, useState } from "react";
import "../index.css";
import { buildVersion } from "../services/buildInfo";
import LinkedInTag from "../components/LinkedInTag";


function ThankYouTwo() {
  const [executed, setExecuted] = useState(false);

  useEffect(() => {
    if (!executed) {
      window.dataLayer.push({
        event: "savingsAccount_ty_noteligible",
      });
      console.log("dataLayer", window.dataLayer);
      setExecuted(true);
    }
      // Initializing the Data Layer on the window object
      window.adobeDataLayer = window.adobeDataLayer || [];
      // Setting Page Level and user-specific variables
      window.adobeDataLayer.push({
        "event": "pageView",
        "web": {
          "webPageDetails": {
            "pageViews": {
              "value": 1
            },
            "name": "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:not eligible thankyou page",
                      
            "URL": window.location.href,
            "isErrorPage": "False",
          }
        },
        "_icicibank": {
          "channelInfo": {
            "version": buildVersion,
            "name": "nli",
          },
          "pageInfo": {
            "language": "en",
            "country": "in",
            "pageType": "campaign", 
            "virtualPageView": "no vpv",
            "journey": "na",
            "subJourney": "na",
            "subSubJourney": "na",
          },
          "userInfo": {
            "userType": "na"
          },
          "errorInfo": {
            "errorType": "na",
            "errorDetails": "na"
          }
        }
      });
  }, []);
  return (
    <>
    <LinkedInTag />
      <article className="thankyou_sec">
        <div className="container ">
          {/* <div className="tick">
            <img
              src="../dist/img/tick.webp"
              alt="tick"
              width="100"
              height="100"
              className="img-fluid"
            />
          </div> */}
          <div className="thankyou_txt noteligible">
            <p>
              We are unable to process your request.
              <br />
              Regret the inconvenience caused.
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default ThankYouTwo;
